export const TelefonoRegex = /^[+1-9][0-9]{9,13}$/;
export const DocumentoRegex = /^[0-9]+$/;
export const CodigoPostalRegex = /^([0-9]{4}|[A-Z]{0,3}[0-9]{4}[A-Z]{1})$/;
export const CUITRegex = /[0-9]{11}/;
export const CASRegex = /^[0-9]{1,7}-[0-9]{2}-[0-9]{1}$/;
